// Mock data for Uz-Space Real Estate Platform

export const translations = {
  en: {
    brand: "Uz-Space",
    tagline: "Find Your Dream Property in Uzbekistan",
    heroSubtitle: "Discover apartments, houses, and commercial properties across Tashkent's finest districts",
    searchPlaceholder: "Search by location, property type...",
    search: "Search",
    filters: "Filters",
    propertyTypes: "Property Types",
    apartments: "Apartments",
    houses: "Houses",
    commercial: "Commercial",
    allTypes: "All Types",
    priceRange: "Price Range",
    bedrooms: "Bedrooms",
    area: "Area",
    sqm: "sq.m",
    viewDetails: "View Details",
    login: "Login",
    signup: "Sign Up",
    logout: "Logout",
    profile: "Profile",
    adminPanel: "Admin Panel",
    addProperty: "Add Property",
    editProperty: "Edit Property",
    deleteProperty: "Delete Property",
    propertyName: "Property Name",
    description: "Description",
    price: "Price",
    address: "Address",
    district: "District",
    save: "Save",
    cancel: "Cancel",
    featuredProperties: "Featured Properties",
    exploreDistricts: "Explore Districts",
    aboutUs: "About Us",
    contact: "Contact",
    home: "Home",
    map: "Map",
    properties: "Properties",
    whyChooseUs: "Why Choose Uz-Space",
    trustedPartners: "Trusted by thousands of families",
    verifiedListings: "Verified Listings",
    expertSupport: "Expert Support",
    secureDeals: "Secure Deals",
    wideSelection: "Wide Selection",
    footer: "© 2025 Uz-Space. All rights reserved.",
    rooms: "Rooms",
    bathroom: "Bathroom",
    parking: "Parking",
    year: "Year",
    floor: "Floor",
    features: "Features",
    contactAgent: "Contact Agent",
    scheduleViewing: "Schedule Viewing",
    similarProperties: "Similar Properties",
    backToMap: "Back to Map",
    selectDistrict: "Select District",
    propertiesInDistrict: "properties in this district",
    from: "from",
    perMonth: "/month",
    forSale: "For Sale",
    forRent: "For Rent",
    new: "New",
    hot: "Hot",
    premium: "Premium"
  },
  ru: {
    brand: "Uz-Space",
    tagline: "Найдите недвижимость мечты в Узбекистане",
    heroSubtitle: "Откройте для себя квартиры, дома и коммерческую недвижимость в лучших районах Ташкента",
    searchPlaceholder: "Поиск по локации, типу недвижимости...",
    search: "Поиск",
    filters: "Фильтры",
    propertyTypes: "Типы недвижимости",
    apartments: "Квартиры",
    houses: "Дома",
    commercial: "Коммерческая",
    allTypes: "Все типы",
    priceRange: "Ценовой диапазон",
    bedrooms: "Спальни",
    area: "Площадь",
    sqm: "кв.м",
    viewDetails: "Подробнее",
    login: "Войти",
    signup: "Регистрация",
    logout: "Выйти",
    profile: "Профиль",
    adminPanel: "Панель админа",
    addProperty: "Добавить объект",
    editProperty: "Редактировать",
    deleteProperty: "Удалить",
    propertyName: "Название",
    description: "Описание",
    price: "Цена",
    address: "Адрес",
    district: "Район",
    save: "Сохранить",
    cancel: "Отмена",
    featuredProperties: "Рекомендуемые объекты",
    exploreDistricts: "Исследуйте районы",
    aboutUs: "О нас",
    contact: "Контакты",
    home: "Главная",
    map: "Карта",
    properties: "Объекты",
    whyChooseUs: "Почему выбирают Uz-Space",
    trustedPartners: "Нам доверяют тысячи семей",
    verifiedListings: "Проверенные объявления",
    expertSupport: "Экспертная поддержка",
    secureDeals: "Безопасные сделки",
    wideSelection: "Широкий выбор",
    footer: "© 2025 Uz-Space. Все права защищены.",
    rooms: "Комнаты",
    bathroom: "Ванная",
    parking: "Парковка",
    year: "Год",
    floor: "Этаж",
    features: "Удобства",
    contactAgent: "Связаться с агентом",
    scheduleViewing: "Запланировать просмотр",
    similarProperties: "Похожие объекты",
    backToMap: "Назад к карте",
    selectDistrict: "Выберите район",
    propertiesInDistrict: "объектов в районе",
    from: "от",
    perMonth: "/месяц",
    forSale: "Продажа",
    forRent: "Аренда",
    new: "Новое",
    hot: "Горячее",
    premium: "Премиум"
  },
  uz: {
    brand: "Uz-Space",
    tagline: "O'zbekistonda orzuingizdagi mulkni toping",
    heroSubtitle: "Toshkentning eng yaxshi tumanlarida kvartiralar, uylar va tijorat ko'chmas mulkini kashf eting",
    searchPlaceholder: "Joylashuv, mulk turi bo'yicha qidirish...",
    search: "Qidirish",
    filters: "Filterlar",
    propertyTypes: "Mulk turlari",
    apartments: "Kvartiralar",
    houses: "Uylar",
    commercial: "Tijorat",
    allTypes: "Barcha turlar",
    priceRange: "Narx oralig'i",
    bedrooms: "Yotoq xonalari",
    area: "Maydon",
    sqm: "kv.m",
    viewDetails: "Batafsil",
    login: "Kirish",
    signup: "Ro'yxatdan o'tish",
    logout: "Chiqish",
    profile: "Profil",
    adminPanel: "Admin paneli",
    addProperty: "Mulk qo'shish",
    editProperty: "Tahrirlash",
    deleteProperty: "O'chirish",
    propertyName: "Mulk nomi",
    description: "Tavsif",
    price: "Narx",
    address: "Manzil",
    district: "Tuman",
    save: "Saqlash",
    cancel: "Bekor qilish",
    featuredProperties: "Tavsiya etilgan mulklar",
    exploreDistricts: "Tumanlarni o'rganing",
    aboutUs: "Biz haqimizda",
    contact: "Aloqa",
    home: "Bosh sahifa",
    map: "Xarita",
    properties: "Mulklar",
    whyChooseUs: "Nima uchun Uz-Space",
    trustedPartners: "Minglab oilalar bizga ishonadi",
    verifiedListings: "Tasdiqlangan e'lonlar",
    expertSupport: "Ekspert yordami",
    secureDeals: "Xavfsiz bitimlar",
    wideSelection: "Keng tanlov",
    footer: "© 2025 Uz-Space. Barcha huquqlar himoyalangan.",
    rooms: "Xonalar",
    bathroom: "Hammom",
    parking: "Avtoturargoh",
    year: "Yil",
    floor: "Qavat",
    features: "Xususiyatlar",
    contactAgent: "Agent bilan bog'lanish",
    scheduleViewing: "Ko'rishni rejalashtirish",
    similarProperties: "O'xshash mulklar",
    backToMap: "Xaritaga qaytish",
    selectDistrict: "Tumanni tanlang",
    propertiesInDistrict: "bu tumandagi mulklar",
    from: "dan",
    perMonth: "/oy",
    forSale: "Sotuvda",
    forRent: "Ijaraga",
    new: "Yangi",
    hot: "Issiq",
    premium: "Premium"
  }
};

export const districts = [
  { id: "chilanzar", name: { en: "Chilanzar", ru: "Чиланзар", uz: "Chilonzor" }, lat: 41.2765, lng: 69.2043, propertyCount: 45 },
  { id: "mirzo-ulugbek", name: { en: "Mirzo Ulugbek", ru: "Мирзо Улугбек", uz: "Mirzo Ulug'bek" }, lat: 41.3385, lng: 69.3348, propertyCount: 38 },
  { id: "yakkasaray", name: { en: "Yakkasaray", ru: "Яккасарай", uz: "Yakkasaroy" }, lat: 41.2947, lng: 69.2731, propertyCount: 52 },
  { id: "sergeli", name: { en: "Sergeli", ru: "Сергели", uz: "Sergeli" }, lat: 41.2271, lng: 69.2159, propertyCount: 28 },
  { id: "shaykhantahur", name: { en: "Shaykhantahur", ru: "Шайхантахур", uz: "Shayxontohur" }, lat: 41.3306, lng: 69.2431, propertyCount: 41 },
  { id: "almazar", name: { en: "Almazar", ru: "Алмазар", uz: "Olmazor" }, lat: 41.3417, lng: 69.2048, propertyCount: 33 },
  { id: "bektemir", name: { en: "Bektemir", ru: "Бектемир", uz: "Bektemir" }, lat: 41.2024, lng: 69.3348, propertyCount: 22 },
  { id: "mirabad", name: { en: "Mirabad", ru: "Мирабад", uz: "Mirobod" }, lat: 41.3011, lng: 69.2847, propertyCount: 67 },
  { id: "uchtepa", name: { en: "Uchtepa", ru: "Учтепа", uz: "Uchtepa" }, lat: 41.3193, lng: 69.1748, propertyCount: 31 },
  { id: "yashnabad", name: { en: "Yashnabad", ru: "Яшнабад", uz: "Yashnobod" }, lat: 41.2843, lng: 69.3531, propertyCount: 25 },
  { id: "yunusabad", name: { en: "Yunusabad", ru: "Юнусабад", uz: "Yunusobod" }, lat: 41.3651, lng: 69.2847, propertyCount: 58 }
];

export const properties = [
  {
    id: "prop-001",
    title: { en: "Luxury Penthouse in Mirabad", ru: "Роскошный пентхаус в Мирабаде", uz: "Mirobodda hashamatli penthouse" },
    type: "apartment",
    price: 450000,
    priceType: "sale",
    district: "mirabad",
    address: { en: "Amir Temur Avenue 45", ru: "Проспект Амира Темура 45", uz: "Amir Temur shoh ko'chasi 45" },
    lat: 41.3015,
    lng: 69.2850,
    bedrooms: 4,
    bathrooms: 3,
    area: 220,
    floor: 15,
    totalFloors: 16,
    year: 2023,
    parking: true,
    features: ["Pool", "Gym", "Concierge", "Smart Home"],
    images: ["https://images.unsplash.com/photo-1515263487990-61b07816b324", "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688"],
    description: { 
      en: "Stunning penthouse with panoramic city views, featuring modern design and premium amenities.",
      ru: "Потрясающий пентхаус с панорамным видом на город, современный дизайн и премиальные удобства.",
      uz: "Shahar manzarasi ko'rinadigan ajoyib penthouse, zamonaviy dizayn va premium qulayliklar."
    },
    badge: "premium",
    isNew: true
  },
  {
    id: "prop-002",
    title: { en: "Cozy Studio in Yunusabad", ru: "Уютная студия в Юнусабаде", uz: "Yunusobodda shinam studiya" },
    type: "apartment",
    price: 850,
    priceType: "rent",
    district: "yunusabad",
    address: { en: "Bogishamol Street 12", ru: "Улица Богишамол 12", uz: "Bog'ishamol ko'chasi 12" },
    lat: 41.3655,
    lng: 69.2850,
    bedrooms: 1,
    bathrooms: 1,
    area: 45,
    floor: 8,
    totalFloors: 12,
    year: 2021,
    parking: false,
    features: ["Furnished", "AC", "Internet"],
    images: ["https://images.unsplash.com/photo-1522708323590-d24dbb6b0267", "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2"],
    description: {
      en: "Modern studio apartment perfect for young professionals, fully furnished with all amenities.",
      ru: "Современная студия, идеально подходящая для молодых специалистов, полностью меблированная.",
      uz: "Yosh mutaxassislar uchun ideal zamonaviy studiya, to'liq jihozlangan."
    },
    badge: "hot",
    isNew: false
  },
  {
    id: "prop-003",
    title: { en: "Family House in Chilanzar", ru: "Семейный дом в Чиланзаре", uz: "Chilonzorda oilaviy uy" },
    type: "house",
    price: 280000,
    priceType: "sale",
    district: "chilanzar",
    address: { en: "Chilanzar 7th Quarter", ru: "Чиланзар 7-й квартал", uz: "Chilonzor 7-mavze" },
    lat: 41.2770,
    lng: 69.2050,
    bedrooms: 5,
    bathrooms: 3,
    area: 350,
    floor: 2,
    totalFloors: 2,
    year: 2019,
    parking: true,
    features: ["Garden", "Garage", "BBQ Area", "Security"],
    images: ["https://images.unsplash.com/photo-1564013799919-ab600027ffc6", "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9"],
    description: {
      en: "Spacious family house with beautiful garden, perfect for large families seeking comfort and privacy.",
      ru: "Просторный семейный дом с красивым садом, идеален для больших семей.",
      uz: "Chiroyli bog'li keng oilaviy uy, katta oilalar uchun ideal."
    },
    badge: null,
    isNew: true
  },
  {
    id: "prop-004",
    title: { en: "Office Space in Mirzo Ulugbek", ru: "Офис в Мирзо Улугбеке", uz: "Mirzo Ulug'bekda ofis" },
    type: "commercial",
    price: 2500,
    priceType: "rent",
    district: "mirzo-ulugbek",
    address: { en: "Mirzo Ulugbek Avenue 88", ru: "Проспект Мирзо Улугбека 88", uz: "Mirzo Ulug'bek shoh ko'chasi 88" },
    lat: 41.3390,
    lng: 69.3350,
    bedrooms: 0,
    bathrooms: 2,
    area: 150,
    floor: 3,
    totalFloors: 10,
    year: 2022,
    parking: true,
    features: ["Reception", "Meeting Rooms", "24/7 Access", "Elevator"],
    images: ["https://images.unsplash.com/photo-1497366216548-37526070297c", "https://images.unsplash.com/photo-1497366811353-6870744d04b2"],
    description: {
      en: "Modern office space in a prestigious business center with all necessary infrastructure.",
      ru: "Современный офис в престижном бизнес-центре со всей необходимой инфраструктурой.",
      uz: "Nufuzli biznes markazida zamonaviy ofis, barcha zarur infratuzilma bilan."
    },
    badge: "new",
    isNew: true
  },
  {
    id: "prop-005",
    title: { en: "Modern Apartment in Yakkasaray", ru: "Современная квартира в Яккасарае", uz: "Yakkasaroyda zamonaviy kvartira" },
    type: "apartment",
    price: 165000,
    priceType: "sale",
    district: "yakkasaray",
    address: { en: "Shota Rustaveli Street 25", ru: "Улица Шота Руставели 25", uz: "Shota Rustaveli ko'chasi 25" },
    lat: 41.2950,
    lng: 69.2735,
    bedrooms: 3,
    bathrooms: 2,
    area: 120,
    floor: 6,
    totalFloors: 9,
    year: 2020,
    parking: true,
    features: ["Balcony", "Storage", "Intercom", "Renovated"],
    images: ["https://images.unsplash.com/photo-1512917774080-9991f1c4c750", "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2"],
    description: {
      en: "Beautifully renovated apartment in the heart of Yakkasaray with modern finishes.",
      ru: "Красиво отремонтированная квартира в центре Яккасарая с современной отделкой.",
      uz: "Yakkasaroy markazida go'zal ta'mirlangan kvartira, zamonaviy pardozlar bilan."
    },
    badge: null,
    isNew: false
  },
  {
    id: "prop-006",
    title: { en: "Villa with Pool in Sergeli", ru: "Вилла с бассейном в Сергели", uz: "Sergelidagi basseynli villa" },
    type: "house",
    price: 520000,
    priceType: "sale",
    district: "sergeli",
    address: { en: "Sergeli District 5", ru: "Сергели район 5", uz: "Sergeli tumani 5" },
    lat: 41.2275,
    lng: 69.2165,
    bedrooms: 6,
    bathrooms: 4,
    area: 450,
    floor: 3,
    totalFloors: 3,
    year: 2021,
    parking: true,
    features: ["Pool", "Sauna", "Wine Cellar", "Smart Home", "Solar Panels"],
    images: ["https://images.unsplash.com/photo-1613490493576-7fde63acd811", "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c"],
    description: {
      en: "Exclusive villa with private pool, premium finishes, and state-of-the-art smart home technology.",
      ru: "Эксклюзивная вилла с бассейном, премиум отделкой и умным домом.",
      uz: "Shaxsiy havuzli eksklyuziv villa, premium pardozlar va smart home texnologiyalari."
    },
    badge: "premium",
    isNew: true
  },
  {
    id: "prop-007",
    title: { en: "Retail Space in Shaykhantahur", ru: "Торговое помещение в Шайхантахуре", uz: "Shayxontohurda savdo joyi" },
    type: "commercial",
    price: 180000,
    priceType: "sale",
    district: "shaykhantahur",
    address: { en: "Navoi Street 55", ru: "Улица Навои 55", uz: "Navoiy ko'chasi 55" },
    lat: 41.3310,
    lng: 69.2435,
    bedrooms: 0,
    bathrooms: 1,
    area: 85,
    floor: 1,
    totalFloors: 5,
    year: 2018,
    parking: false,
    features: ["Street Front", "High Ceiling", "AC"],
    images: ["https://images.unsplash.com/photo-1441986300917-64674bd600d8", "https://images.unsplash.com/photo-1604719312566-8912e9227c6a"],
    description: {
      en: "Prime retail location on busy Navoi Street with high foot traffic and visibility.",
      ru: "Отличная торговая локация на оживленной улице Навои с высоким трафиком.",
      uz: "Gavjum Navoiy ko'chasida ajoyib savdo joylashuvi, yuqori odam oqimi bilan."
    },
    badge: "hot",
    isNew: false
  },
  {
    id: "prop-008",
    title: { en: "Budget Apartment in Almazar", ru: "Бюджетная квартира в Алмазаре", uz: "Olmazorda byudjet kvartira" },
    type: "apartment",
    price: 450,
    priceType: "rent",
    district: "almazar",
    address: { en: "Almazar District 3", ru: "Алмазар район 3", uz: "Olmazor tumani 3" },
    lat: 41.3420,
    lng: 69.2055,
    bedrooms: 2,
    bathrooms: 1,
    area: 60,
    floor: 4,
    totalFloors: 5,
    year: 2015,
    parking: false,
    features: ["Furnished", "Near Metro", "Market Nearby"],
    images: ["https://images.unsplash.com/photo-1493809842364-78817add7ffb", "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688"],
    description: {
      en: "Affordable furnished apartment near metro station, perfect for students or young couples.",
      ru: "Доступная меблированная квартира рядом с метро, идеальна для студентов.",
      uz: "Metro yaqinida arzon jihozlangan kvartira, talabalar uchun ideal."
    },
    badge: null,
    isNew: false
  }
];

export const features = [
  {
    icon: "Shield",
    title: { en: "Verified Listings", ru: "Проверенные объявления", uz: "Tasdiqlangan e'lonlar" },
    description: { en: "All properties are verified by our team", ru: "Все объекты проверены нашей командой", uz: "Barcha mulklar jamoamiz tomonidan tekshirilgan" }
  },
  {
    icon: "Users",
    title: { en: "Expert Support", ru: "Экспертная поддержка", uz: "Ekspert yordami" },
    description: { en: "24/7 customer support in your language", ru: "Поддержка 24/7 на вашем языке", uz: "24/7 mijozlarni qo'llab-quvvatlash" }
  },
  {
    icon: "Lock",
    title: { en: "Secure Deals", ru: "Безопасные сделки", uz: "Xavfsiz bitimlar" },
    description: { en: "Protected transactions and legal support", ru: "Защищенные транзакции и юридическая поддержка", uz: "Himoyalangan tranzaksiyalar va huquqiy yordam" }
  },
  {
    icon: "Home",
    title: { en: "Wide Selection", ru: "Широкий выбор", uz: "Keng tanlov" },
    description: { en: "Thousands of properties across Tashkent", ru: "Тысячи объектов по всему Ташкенту", uz: "Toshkent bo'ylab minglab mulklar" }
  }
];
